import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import Api from '../../utils/Api';
import { push } from 'react-router-redux';
import {
	LOGIN_USER,
	SET_AUTH_SUCCESS,
	SOCIAL_LOGIN,
	FORGOT_PIN,
	OTP_LOGIN,
	OTP_VERIFY,
	SET_COUNTRY,
	JUNIOR_LOGIN,
	SET_USER_TYPE,
} from './userAuth.actionTypes';
import UserProfileTypes from '../userDetails/userDetails.actionTypes';
import ParentDashboardTypes from '../parentDashboard/parentDashboard.types';
import {
	getLoginId,
	getPin,
	getUserDetails,
	getSocialLoginDetails,
} from './userAuth.selectors';
import UtilsTypes from '../utilities/utils.types';
import Loader from '../../utils/Loader';
import MyCourseActionTypes from '../myCourse/myCourse.types';
import Config from '../../config/Config';
import UserTypes from '../../utils/userTypes';
import { tagEvent } from '../../utils/tagManager';
import { getLoginType } from '../../utils/commonFunctions';

function* handleforgetPassword() {
	try {
		let data = {
			user_name: yield select(getLoginId),
			//center_code: '',
			old_user_name: null,
		};

		const res = yield call(Api, {
			url: 'forgotpassword',
			data,
			method: 'POST',
			headers: {},
		});
		if (res.code !== 200) {
			Loader.hide();
			yield put({
				type: UtilsTypes.SET_ERROR_PANEL,
				payload: {
					panelMsg: res,
					panelClass: 'alert alert-danger',
				},
			});
		} else {
			Loader.hide();
			yield put({
				type: UtilsTypes.SET_ERROR_PANEL,
				payload: {
					panelMsg: 'Pin sent to registered email/mobile number',
					panelClass: 'alert alert-success',
				},
			});
			if (!window.location.href.includes('/verifyuser')) yield put(push('/'));
		}
	} catch (err) {
		console.log('user auth', err);
	}
}

function* loginUser(data) {
	try {
		const res = yield call(Api, {
			url: 'login',
			method: 'POST',
			data: data,
			headers: {},
		});
		if (!res.status) {
			Loader.hide();
			yield put({
				type: UtilsTypes.SET_ERROR_PANEL,
				payload: {
					panelMsg: res,
					panelClass: 'alert alert-danger',
				},
			});
		} else {
			if (res.code === 200) {
				Loader.hide();

				yield put({ type: SET_USER_TYPE, payload: UserTypes.Regular });
				if (!res.data.onboarding) {
					localStorage.setItem('onboardPending', res.data.onboarding);
				}
				const country = yield call(getUserCountry);

				yield put({
					type: SET_COUNTRY,
					payload: !!country && country?.toLowerCase() !== 'india',
				});
				yield put({ type: MyCourseActionTypes.RESET_UNIT_ID });
				localStorage.setItem('login_user_id', res.data.user_id);
				yield put({ type: SET_AUTH_SUCCESS, payload: res.data });
				yield put({ type: UserProfileTypes.GET_USER_PROFILE.PENDING });
			} else {
				Loader.hide();
				yield put({
					type: UtilsTypes.SET_ERROR_PANEL,
					payload: {
						panelMsg: res.message,
						panelClass: 'alert alert-danger',
					},
				});
			}
		}
	} catch (error) {
		console.log(error.message);
	}
}

function* loginJunior({ payload }) {
	try {
		const res = yield call(Api, {
			url: 'login',
			method: 'POST',
			data: { ...payload, keepalive: true },
			headers: {},
		});
		if (!res.status) {
			Loader.hide();
			yield put({
				type: UtilsTypes.SET_ERROR_PANEL,
				payload: {
					panelMsg: res,
					panelClass: 'alert alert-danger',
				},
			});
		} else {
			if (res.code === 200) {
				Loader.hide();

				const {
					activeCourseId,
					user_name,
					token,
					user_id,
					email,
					full_name,
					phone,
					parent_id,
					grade,
					is_paid,
				} = res.data;

				yield put({ type: SET_USER_TYPE, payload: UserTypes.Junior });
				localStorage.setItem('login_user_id', res.data.user_id);
				localStorage.setItem('juniorAccount', true);
				localStorage.setItem('token', token);
				yield put({ type: SET_AUTH_SUCCESS, payload: res.data });
				yield put({
					type: ParentDashboardTypes.GET_CHILD_TOKEN.SUCCESS,
					payload: {
						activeChildId: 0,
						childToken: token,
						child_id: user_id,
						course_id: activeCourseId,
						child_name: user_name,
					},
				});

				yield call(tagEvent, {
					event: 'child_signin',
					user_name,
					user_id,
					parent_id,
					grade,
					is_paid,
				});

				let userDetailsObj = {
					user_mail: email,
					full_name: full_name,
					user_phone: phone,
				};
				localStorage.setItem('userDetails', JSON.stringify(userDetailsObj));
				yield put({ type: UtilsTypes.SET_ERROR_PANEL, payload: {} });
				yield put({
					type: UserProfileTypes.SET_USER_DETAILS,
					payload: { ...res.data, fullName: full_name },
				});
				yield put(push(`/junior/dashboard`));
				//	yield put({ type: UserProfileTypes.GET_USER_PROFILE.PENDING });
			} else {
				Loader.hide();
				yield put({
					type: UtilsTypes.SET_ERROR_PANEL,
					payload: {
						panelMsg: res.message,
						panelClass: 'alert alert-danger',
					},
				});
			}
		}
	} catch (error) {
		console.log(error.message);
	}
}

function* authUserWithOtp({ payload }) {
	try {
		const type = getLoginType(payload);
		yield call(tagEvent, {
			event: 'kids_registration_initiated',
			phone: type === 'phone' ? payload : '',
			email: type === 'email' ? payload : '',
		});
		const res = yield call(Api, {
			url: 'otplogin',
			method: 'POST',
			data: { login_id: payload },
			headers: {},
		});
		if (!res.status) {
			Loader.hide();
			yield put({
				type: UtilsTypes.SET_ERROR_PANEL,
				payload: {
					panelMsg: res,
					panelClass: 'alert alert-danger',
				},
			});
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({ type: OTP_LOGIN.SUCCESS, payload: res.data });
				if (localStorage.getItem('sso') !== '0') {
					yield put(push('/parent/verifyotp'));
				}
			} else {
				Loader.hide();
				yield put({
					type: UtilsTypes.SET_ERROR_PANEL,
					payload: {
						panelMsg: res.message,
						panelClass: 'alert alert-danger',
					},
				});
			}
		}
	} catch (error) {
		console.log(error.message);
	}
}
function* verifyOtp({ payload }) {
	try {
		const { loginId, loginType, userId } = yield select(getUserDetails);
		yield call(tagEvent, {
			event: 'kids_registration_complete',
			user_id: userId,
			phone: loginType === 'phone' ? loginId : '',
			email: loginType === 'email' ? loginId : '',
		});

		const res = yield call(Api, {
			url: 'verifyloginotp',
			method: 'POST',
			data: { ...payload },
			headers: {},
		});
		if (!res.status) {
			Loader.hide();
			yield put({
				type: UtilsTypes.SET_ERROR_PANEL,
				payload: {
					panelMsg: res,
					panelClass: 'alert alert-danger',
				},
			});
		} else {
			if (res.code === 200) {
				Loader.hide();
				localStorage.setItem('token', res.data.token);
				const {
					user_id,
					user_name,
					user_phone,
					user_email,
					new_user,
					isParent,
					hasChildLicense,
				} = res.data;

				yield put({ type: SET_USER_TYPE, payload: UserTypes.Parent });
				if (new_user) {
					yield call(tagEvent, {
						event: 'kids_new_signup',
						user_id,
						phone: user_phone,
						email: user_email,
					});
				}
				yield put({
					type: OTP_VERIFY.SUCCESS,
					payload: {
						userId: user_id,
						userName: user_name,
						userPhone: user_phone,
						userEmail: user_email,
						newUser: new_user,
					},
				});

				yield put({
					type: ParentDashboardTypes.UPDATE_PARENT_NAME.SUCCESS,
					payload: {
						parentName: user_name,
						hasChildLicense,
					},
				});

				yield put({
					type: UserProfileTypes.SET_USER_DETAILS,
					payload: {
						user_profile: { isParent },
					},
				});

				yield put(push('/parent/dashboard'));
			} else {
				Loader.hide();
				yield put({
					type: UtilsTypes.SET_ERROR_PANEL,
					payload: {
						panelMsg: res.message,
						panelClass: 'alert alert-danger',
					},
				});
			}
		}
	} catch (error) {
		console.log(error.message);
	}
}
const getUserLocationGeo = () =>
	new Promise((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(
			(location) => resolve(location),
			(error) => reject(error),
		);
	});

function* getUserCountry() {
	try {
		const location = yield call(getUserLocationGeo);

		const { latitude, longitude } = location?.coords;
		const result = yield fetch(
			`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${Config.GOOGLEAPI}`,
		)
			.then((res) => res.json())
			.then((response) => {
				let country = response.results[0]?.address_components?.filter((x) =>
					x.types.includes('country'),
				);
				return country[0]?.long_name;
			})
			.catch(() => 'India');
		return result;
	} catch (error) {
		console.log('geoLocation error', error);
		return 'India';
	}
}

function* socialLogin() {
	const data = yield select(getSocialLoginDetails);
	let { loginId, userToken, userName, photoUrl, socialDomain } = data;
	let postDate = {
		login_id: loginId,
		user_token: userToken,
		user_name: userName,
		photo_url: photoUrl,
		social_domain: socialDomain,
	};
	yield call(loginUser, postDate);
}

function* emailOrPhoneLogin() {
	let postDate = {
		login_id: yield select(getLoginId),
		pin: yield select(getPin),
		keepalive: true,
	};
	yield call(loginUser, postDate);
}

function* authSocialUserStart() {
	yield takeLatest(SOCIAL_LOGIN.PENDING, socialLogin);
}

function* authenticateUserStart() {
	yield takeLatest(LOGIN_USER.PENDING, emailOrPhoneLogin);
}

function* authUserWithOtpStart() {
	yield takeLatest(OTP_LOGIN.PENDING, authUserWithOtp);
}

function* verifyOtpStart() {
	yield takeLatest(OTP_VERIFY.PENDING, verifyOtp);
}

function* resendPinStart() {
	yield takeLatest(FORGOT_PIN.PENDING, handleforgetPassword);
}

function* loginJuniorStart() {
	yield takeLatest(JUNIOR_LOGIN.PENDING, loginJunior);
}

export function* authSagas() {
	yield all([
		call(authenticateUserStart),
		call(authSocialUserStart),
		call(resendPinStart),
		call(loginJuniorStart),
		call(authUserWithOtpStart),
		call(verifyOtpStart),
	]);
}
